module.exports = __webpack_public_path__ + "img/jd.1ceec5c3.png";